<template>
    <slot>
        <InfinityBgGradient :layer="layer" />
        <InfinityBgShape :layer="layer" />
    </slot>
</template>

<script setup>
    import { computed } from 'vue';

    import { useThreeObject } from '@resn/gozer-vue';

    import InfinityBgGradient from './InfinityBgGradient.vue';
    import InfinityBgShape from './InfinityBgShape.vue';

    const props = defineProps({
        layer: {
            type: Number,
            default: 0,
        },
        visible: {
            type: Boolean,
            default: false,
        },
    });

    const v = computed(() => props.visible);

    useThreeObject(null, {
        name: 'InfinityBg',
        props: { v },
    });
</script>
